export const colorsDictionary = [
  // ht categories
  {
    category: 'COVID-19',
    color: '#007C1F'
  },
  {
    category: 'PRC PROMOTION',
    color: '#FF3366'
  },
  {
    category: 'INTERNATIONAL SOLIDARITY AND SOUTH-SOUTH COOPERATION',
    color: '#9966FF'
  },
  {
    category: 'TECHNOLOGICAL ADVANCES PRC',
    color: '#65327E'
  },
  {
    category: 'ORGANISMS FORUMS AND MULTILATERAL SPACES',
    color: '#666600'
  },
  {
    category: 'BINATIONAL RELATIONS PRC - LAC',
    color: '#6699FF'
  },
  {
    category: 'PRC GOVERNMENT',
    color: '#33CC99'
  },
  {
    category: 'U.S.A.',
    color: '#996633'
  },
  {
    category: 'TRUTH INFORMATION',
    color: '#CCAAFF'
  },
  {
    category: 'ENVIRONMENT AND BIODIVERSITY',
    color: '#ff9900'
  },
  {
    category: 'PRC COMPANIES',
    color: '#AFFaaf'
  },
  {
    category: 'LAC COMPANIES',
    color: '#5a815a'
  },
  // analisis categories
  {
    category: 'Citizen.',
    color: '#0042A1'
  },
  {
    category: 'LAC Governments and Government Entities.',
    color: '#669999'
  },
  {
    category: 'Suspended or Deleted Account',
    color: '#cccccc'
  },
  {
    category: 'LAC Companies and Private Organizations',
    color: '#006699'
  },
  {
    category: 'Media and Promotion Sites of PRC.',
    color: '#0099ff'
  },
  {
    category: 'Binational Organizations PRC - LAC',
    color: '#663300'
  },
  {
    category: 'LAC Research and Higher Education Centers',
    color: '#669900'
  },
  {
    category: 'Influencers.',
    color: '#990099'
  },
  {
    category: 'Multilateral Organizations, Forums, and Spaces',
    color: '#666600'
  },
  {
    category: 'LAC Media.',
    color: '#006600'
  },
  {
    category: 'PRC government.',
    color: '#33CC99'
  },
  {
    category: 'PRC Government.',
    color: '#33CC99'
  },
  {
    category: 'N/A',
    color: '#cccccc'
  },
  {
    category: 'Content Amplifier',
    color: '#a399CC'
  },
  {
    category: 'Foreign governments.',
    color: '#ff99aa'
  },
  {
    category: 'BOTs',
    color: '#cc11cc'
  },
  {
    category: 'Foreign Media.',
    color: '#ABC'
  },
  {
    category: 'Foreign Companies',
    color: '#aa11ff'
  },
  {
    category: 'PRC or Taiwanese citizen',
    color: '#aaafff'
  },
  {
    category: 'PRC Companies.',
    color: '#1ffa11'
  },
  {
    category: 'Foreign Research and Higher Education Centers',
    color: '#ff99cc'
  },
  {
    category: 'PRC Civil Organizations',
    color: '#004d4d'
  }
]
